import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(2.5),
    right: theme.spacing(2),
  },
}));
